module.exports = __webpack_public_path__ + "img/9791187980957.cec9456e.jpg";